import { connect } from 'react-redux';
import { compose } from 'recompose';
import { partial } from 'lodash';
import { change, reduxForm } from 'redux-form';
import { FORM } from '../../../formBarbers/barberForm/constants';
import { validate } from '../helpers/validationSchema';

const withReduxForm = compose(
  connect(null, {
    change: partial(change, FORM),
  }),
  reduxForm({
    enableReinitialize: true,
    form: FORM,
    validate,
  }),
);
export default withReduxForm;
